// @flow

import { getRoute, isEnabled } from 'Config';
import { desktopCanvasAnimation, desktopSideAnimation, mobileAnimation } from 'Lib/animation';
import isInStandaloneMode from 'Lib/utils/isInStandaloneMode';

import { LIKES_YOU_TAB, MY_LIKES_TAB } from 'Containers/LikesYou/constants';
import LoginLite from 'Containers/LoginPage/Lite';
// Leave Mobile for SEO
import LoginMobile from 'Containers/LoginPage/Mobile';
import { MUTUAL_FRIENDS_SETTINGS_ROUTE } from 'Containers/SettingsPage/Connections/constants';
import { MUTUAL_FRIENDS_MENU_ITEM_TITLE_ID } from 'Containers/SettingsPage/Connections/constants/copy';
import Loadable from 'Components/AsyncComponent';
import LoadingScreen from 'Components/LoadingScreen';

import {
  handleLoginRoute,
  redirectToEditProfile,
  redirectToExplore,
  redirectToGiftCard,
  redirectToRecs,
  redirectToRoot,
  redirectToSettings,
  verifyAgeVerificationDeeplinkRoute,
  verifyCampaignDeeplinkRoute,
  verifyCheckoutRoute,
  verifyConfirmationDeeplinkRoute,
  verifyEmailRemovalDeeplinkRoute,
  verifyEmailSubscriptionTokenRoute,
  verifyExploreRoute,
  verifyGoldDeeplinkRoute,
  verifyGoldRoute,
  verifyIncentivesDeeplinkRoute,
  verifyMerchandisingRoute,
  verifyMessagesRoute,
  verifyMutualFriendsRoute,
  verifyNavigateRoute,
  verifyPlusRoute,
  verifyPreferencesRoute,
  verifyPromoRoute,
  verifySettingsRoute,
  verifyWebProfileRoute,
} from './verification';

/**
 * Defered bundle
 */
const RecsPage = Loadable({
  name: 'RecsPage',
  loader: () => import('Containers/RecsPage' /* webpackChunkName: "pc-r-RecsPage" */),
});

const ProfileCover = Loadable({
  name: 'ProfileCover',
  loader: () =>
    import('Containers/ProfilePage/ProfileCover' /* webpackChunkName: "pc-r-ProfileCover" */),
});

const ProfilePage = Loadable({
  name: 'ProfilePage',
  loader: () => import('Containers/ProfilePage' /* webpackChunkName: "pc-r-ProfilePage" */),
});

const RecProfile = Loadable({
  name: 'RecProfile',
  loader: () => import('Containers/RecProfile' /* webpackChunkName: "pc-r-RecProfile" */),
});

const ChatProfile = Loadable({
  name: 'ChatProfile',
  loader: () => import('Containers/ChatProfile' /* webpackChunkName: "pc-r-ChatProfile" */),
});

const MatchlistPage = Loadable({
  name: 'MatchlistPage',
  loader: () => import('Containers/MatchlistPage' /* webpackChunkName: "pc-r-MatchlistPage" */),
});

const Settings = Loadable({
  name: 'Settings',
  loader: () => import('Containers/SettingsPage' /* webpackChunkName: "pc-r-Settings" */),
});

const LeverOverrideSettings = Loadable({
  name: 'LeverOverrideSettings',
  loader: () =>
    import('Containers/SettingsPage/LeverOverrideSettings' /* webpackChunkName: "pc-r-DevTools" */),
});

const StacksUtil = Loadable({
  name: 'StacksUtil',
  loader: () =>
    import('Containers/StacksUtil/StacksUtilSettings' /* webpackChunkName: "pc-r-StacksUtil" */),
});

const EmailNotificationSettings = Loadable({
  name: 'EmailNotificationSettings',
  loader: () =>
    import(
      'Containers/SettingsPage/NotificationSettings/EmailNotificationSettings' /* webpackChunkName: "pc-r-EmailSettings" */
    ),
});

const PushNotificationSettings = Loadable({
  name: 'PushNotificationSettings',
  loader: () =>
    import(
      'Containers/SettingsPage/NotificationSettings/PushNotificationSettings' /* webpackChunkName: "pc-r-PushSettings" */
    ),
});

const WebProfileSettings = Loadable({
  name: 'WebProfileSettings',
  loader: () =>
    import(
      'Containers/SettingsPage/WebProfile/WebProfileSettings' /* webpackChunkName: "pc-r-WebProfileSettings" */
    ),
});

const SuggestionsConsentSettings = Loadable({
  name: 'SuggestionsConsentSettings',
  loader: () =>
    import(
      'Containers/SettingsPage/MessageDataConsentSettings/SuggestionsConsentSettings' /* webpackChunkName: "pc-r-SuggestionsConsentSettings" */
    ),
});

const ReadReceiptSettings = Loadable({
  name: 'ReadReceiptSettings',
  loader: () =>
    import(
      'Containers/SettingsPage/RevenueFeatureSettings/ReadReceiptSettings' /* webpackChunkName: "pc-r-ReadReceiptSettings" */
    ),
});

const RecentlyActiveSettings = Loadable({
  name: 'RecentlyActiveSettings',
  loader: () =>
    import(
      'Containers/SettingsPage/RevenueFeatureSettings/RecentlyActiveSettings' /* webpackChunkName: "pc-r-RecentlyActiveSettings" */
    ),
});

const ExListSettings = Loadable({
  name: 'ExListSettings',
  loader: () =>
    import(
      'Containers/SettingsPage/ExList/ExListSettings' /* webpackChunkName: "pc-r-ExListSettings" */
    ),
});

const ExListAddContact = Loadable({
  name: 'ExListSettings',
  loader: () =>
    import(
      'Containers/SettingsPage/ExList/screens/AddContact' /* webpackChunkName: "pc-r-ExListAddContact" */
    ),
});

const SubSettings = Loadable({
  name: 'SubSettings',
  loader: () =>
    import('Containers/SettingsPage/SubSettings' /* webpackChunkName: "pc-r-SubSettings" */),
});

const SubscriptionMerchandisingPage = Loadable({
  name: 'SubscriptionMerchandisingPage',
  loader: () =>
    import(
      'Containers/SubscriptionMerchandisingPage' /* webpackChunkName: "pc-r-SubscriptionMerchandisingPage" */
    ),
});

const LoginDesktop = Loadable({
  name: 'LoginDesktop',
  loader: () => import('Containers/LoginPage/Desktop' /* webpackChunkName: "pc-r-LoginDesktop" */),
});

const WardenPage = Loadable({
  name: 'WardenPage',
  loader: () => import('Containers/WardenPage' /* webpackChunkName: "pc-r-WardenPage" */),
});

const SelfieChallengeV2 = Loadable({
  name: 'SelfieChallengeV2',
  loader: () =>
    import('Containers/SelfieChallengeV2' /* webpackChunkName: "pc-r-SelfieChallengeV2" */),
});

const EditProfileMenuWithPreviewPage = Loadable({
  name: 'EditProfileMenuPageWithPreview',
  loader: () =>
    import(
      'Containers/EditProfile/EditProfileMenuWithPreviewPage' /* webpackChunkName: "pc-r-EditProfileMenuWithPreviewPage" */
    ),
});

const EditProfileGenderPage = Loadable({
  name: 'EditProfileGenderPage',
  loader: () =>
    import(
      'Containers/EditProfile/EditProfileGenderPage/ConnectedEditProfileGenderPage' /* webpackChunkName: "pc-r-ConnectedEditProfileGenderPage" */
    ),
});
const ConnectedSearchGenders = Loadable({
  name: 'ConnectedSearchGenders',
  loader: () =>
    import(
      'Containers/EditProfile/ConnectedSearchGenders' /* webpackChunkName: "pc-r-ConnectedSearchGenders" */
    ),
});
const EditProfileOrientationPage = Loadable({
  name: 'EditProfileOrientationPage',
  loader: () =>
    import(
      'Containers/EditProfile/EditProfileOrientationPage/ConnectedEditProfileOrientationPage' /* webpackChunkName: "pc-r-ConnectedEditProfileOrientationPage" */
    ),
});

const EditProfilePromptsPage = Loadable({
  name: 'EditProfilePromptsPage',
  loader: () =>
    import(
      'Containers/EditProfile/EditProfilePromptsPage' /* webpackChunkName: "pc-r-EditProfilePromptsPage" */
    ),
});

const UserVerification = Loadable({
  name: 'UserVerification',
  loader: () =>
    import('Containers/UserVerification' /* webpackChunkName: "pc-r-UserVerification" */),
});

const NotFoundPage = Loadable({
  name: 'NotFoundPage',
  loader: () =>
    import('Containers/ErrorPages/NotFoundPage' /* webpackChunkName: "pc-r-NotFoundPage" */),
});
const ServiceUnavailablePage = Loadable({
  name: 'ServiceUnavailablePage',
  loader: () =>
    import(
      'Containers/ErrorPages/ServiceUnavailablePage' /* webpackChunkName: "pc-r-ServiceUnavailablePage" */
    ),
});
const EmailRemovalPage = Loadable({
  name: 'EmailRemovalPage',
  loader: () =>
    import(
      'Containers/ErrorPages/EmailRemovalPage' /* webpackChunkName: "pc-r-EmailRemovalPage" */
    ),
});

const EmailSubscriptionPage = Loadable({
  name: 'EmailSubscriptionPage',
  loader: () =>
    import(
      'Containers/EmailSubscriptionServicePage' /* webpackChunkName: "pc-r-EmailSubscriptionServicePage" */
    ),
});

const Chat = Loadable({
  name: 'Chat',
  loader: () => import('Containers/Chat' /* webpackChunkName: "pc-r-Chat" */),
});

const DesktopChat = Loadable({
  name: '', // always re-mount desktop chat
  loader: () => import('Containers/DesktopChat' /* webpackChunkName: "pc-r-DesktopChat" */),
});

const DesktopMessageList = Loadable({
  name: 'DesktopMessageList',
  loader: () =>
    import('Containers/DesktopMessageList' /* webpackChunkName: "pc-r-DesktopMessageList" */),
});

const Checkout = Loadable({
  name: 'Checkout',
  loader: () => import('Containers/CheckoutPage/' /* webpackChunkName: "pc-r-CheckoutPage" */),
});

const PreCheckout = Loadable({
  name: 'PreCheckout',
  loader: () => import('Containers/PreCheckoutPage' /* webpackChunkName: "pc-r-PreCheckoutPage" */),
});

const AccountSettings = Loadable({
  name: 'AccountSettings',
  loader: () =>
    import(
      'Containers/SettingsPage/AccountSettings' /* webpackChunkName: "pc-r-AccountSettings" */
    ),
});

const UpdateCard = Loadable({
  name: 'UpdateCard',
  loader: () =>
    import('Containers/CheckoutPage/UpdateCard/' /* webpackChunkName: "pc-r-UpdateCard" */),
});

const PassportPage = Loadable({
  name: 'PassportPage',
  loader: () => import('Containers/PassportPage' /* webpackChunkName: "pc-r-PassportPage" */),
});

const AuthOnboarding = Loadable({
  name: 'AuthOnboarding',
  loader: () => import('Containers/AuthOnboarding' /* webpackChunkName: "pc-r-AuthOnboarding" */),
});

const UserBiometrics = Loadable({
  name: 'UserBiometrics',
  loader: () => import('Containers/UserBiometrics' /* webpackChunkName: "pc-r-UserBiometrics" */),
});

const LikesYou = Loadable({
  name: 'LikesYou',
  loader: () => import('Containers/LikesYou' /* webpackChunkName: "pc-r-LikesYou" */),
});

const TinderUSettingsMenu = Loadable({
  name: 'TinderUSettingsMenu',
  loader: () =>
    import(
      'Containers/SettingsPage/TinderU/TinderUSettingsMenu' /* webpackChunkName: "pc-r-TinderUSettingsMenu" */
    ),
});

const EmailAccountSettings = Loadable({
  name: 'EmailAccountSettings',
  loader: () =>
    import(
      'Containers/SettingsPage/AccountSettings/EmailAccountSettings' /* webpackChunkName: "pc-r-EmailAccountSettings" */
    ),
});

const ConnectedAccountsSettings = Loadable({
  name: 'ConnectedAccountsSettings',
  loader: () =>
    import(
      'Containers/SettingsPage/AccountSettings/ConnectedAccountsSettings' /* webpackChunkName: "pc-r-ConnectedAccountsSettings" */
    ),
});

const PhoneAccountSettings = Loadable({
  name: 'PhoneAccountSettings',
  loader: () =>
    import(
      'Containers/SettingsPage/AccountSettings/PhoneAccountSettings' /* webpackChunkName: "pc-r-PhoneAccountSettings" */
    ),
});

const RemoteView = Loadable({
  name: 'RemoteView',
  loader: () => import('Components/RemoteView' /* webpackChunkName: "pc-r-RemoteView" */),
});

const SelectAnthem = Loadable({
  name: 'SelectAnthem',
  loader: () =>
    import(
      'Containers/EditProfile/EditProfileMenuPage/SelectAnthem' /* webpackChunkName: "pc-r-SelectAnthem" */
    ),
});

const SelectTopArtists = Loadable({
  name: 'SelectTopArtists',
  loader: () =>
    import(
      'Containers/EditProfile/EditProfileMenuPage/SelectTopArtists' /* webpackChunkName: "pc-r-SelectTopArtists" */
    ),
});

const SelectSchool = Loadable({
  name: 'SelectSchool',
  loader: () =>
    import(
      'Containers/EditProfile/EditProfileMenuPage/SelectSchool' /* webpackChunkName: "pc-r-SelectSchool" */
    ),
});

const SelectCity = Loadable({
  name: 'SelectCity',
  loader: () =>
    import(
      'Containers/EditProfile/EditProfileMenuPage/SelectCity' /* webpackChunkName: "pc-r-SelectCity" */
    ),
});

const SelectInterests = Loadable({
  name: 'SelectInterests',
  loader: () =>
    import(
      'Containers/EditProfile/EditProfileMenuPage/SelectInterests' /* webpackChunkName: "pc-r-SelectInterests" */
    ),
});

const WebProfile = Loadable({
  name: 'WebProfile',
  loader: () => import('Containers/WebProfile' /* webpackChunkName: "pc-r-WebProfile" */),
});

const GlobalModeSettings = Loadable({
  name: 'GlobalModeSettings',
  loader: () =>
    import(
      'Containers/SettingsPage/DiscoverySettings/GlobalModeSettings' /* webpackChunkName: "pc-r-GlobalModeSettings" */
    ),
});
const EditStickers = Loadable({
  name: 'EditStickers',
  loader: () =>
    import('Containers/EditProfile/EditStickers' /* webpackChunkName: "pc-r-EditStickers" */),
});

const Campaign = Loadable({
  name: 'Campaign',
  loader: () => import('Containers/Campaign' /* webpackChunkName: "pc-r-Campaign" */),
});

const SelfieChallenge = Loadable({
  name: 'SelfieChallenge',
  loader: () => import('Containers/SelfieChallenge' /* webpackChunkName: "pc-r-SelfieChallenge" */),
});

const MessageControlsSettings = Loadable({
  name: 'MessageControlsSettings',
  loader: () =>
    import(
      'Containers/SettingsPage/MessagePreferences/MessageControlsSettings' /* webpackChunkName: "pc-r-MessageControlsSettings" */
    ),
});

const ExploreCatalogPage = Loadable({
  name: 'ExploreCatalog',
  loader: () =>
    import('Containers/Explore/CatalogPage' /* webpackChunkName: "pc-r-ExploreCatalog" */),
});

const ExploreCuratedRecsPage = Loadable({
  name: 'ExploreCuratedRecs',
  loader: () =>
    import('Containers/Explore/CuratedRecsPage' /* webpackChunkName: "pc-r-ExploreCuratedRecs" */),
});

const MatchExpirationArchived = Loadable({
  name: 'ArchivedMatches',
  loader: () =>
    import(
      'Containers/MatchExpiration/pages/ArchivedMatches' /* webpackChunkName: "pc-r-MatchlistPage-TopNav" */
    ),
});

const MatchlistPageTopNav = Loadable({
  name: 'MatchListPageTopNav',
  loader: () =>
    import('Containers/MatchlistPage/TopNav' /* webpackChunkName: "pc-r-MatchlistPage-TopNav" */),
});

const MutualFriendsSubSettings = Loadable({
  name: 'MutualFriendsSubSettings',
  loader: () =>
    import(
      'Containers/SettingsPage/Connections/MutualFriends/SubSettings' /* webpackChunkName: "pc-r-MutualFriendsSubSettings" */
    ),
});

const MmEntry = Loadable({
  name: 'MmEntry',
  loader: () => import('Containers/MM' /* webpackChunkName: "pc-r-MM" */),
});

const MmProfile = Loadable({
  name: 'MmProfile',
  loader: () => import('Containers/MM/pages/Profile' /* webpackChunkName: "pc-r-MM-profile" */),
});

const TinderSelectOnboarding = Loadable({
  name: 'TinderSelectOnboarding',
  loader: () =>
    import('Containers/TinderSelect' /* webpackChunkName: "pc-r-TinderSelect-Onboarding" */),
});

const TinderSelectPreCheckoutPage = Loadable({
  name: 'TinderSelectPreCheckoutPage',
  loader: () =>
    import(
      'Containers/TinderSelect/components/TinderSelectPreCheckoutPage' /* webpackChunkName: "pc-r-TinderSelect-PreCheckoutPage" */
    ),
});

const GiftCardPage = Loadable({
  name: 'GiftCardPage',
  loader: () => import('Containers/GiftCardPage' /* webpackChunkName: "pc-r-GiftCardPage" */),
});

const AppealsCenterPage = Loadable({
  name: 'AppealsCenterPage',
  loader: () => import('Containers/AppealsCenter' /* webpackChunkName: "pc-r-AppealsCenterPage" */),
});

const PreferencesDescriptorSelection = Loadable({
  name: 'PreferencesDescriptorSelection',
  loader: () =>
    import(
      'Containers/SettingsPage/Preferences/PreferencesDescriptorSelection' /* webpackChunkName: "pc-r-PreferencesDescriptorSelection" */
    ),
});

const PreferencesInterestsSelection = Loadable({
  name: 'PreferencesInterestsSelection',
  loader: () =>
    import(
      'Containers/SettingsPage/Preferences/PreferencesInterestsSelection' /* webpackChunkName: "pc-r-PreferencesInterestsSelection" */
    ),
});

const routesConfig = [
  {
    path: getRoute('recs'),
    exact: true,
    regions: {
      main: RecsPage,
      side: DesktopMessageList,
      canvas: RecsPage,
    },
    prefetch: [RecProfile, Chat, DesktopChat, LikesYou],
    animation: {
      main: mobileAnimation.initial,
      side: desktopSideAnimation.initial,
      canvas: desktopCanvasAnimation.initial,
    },
    showMobileBackground: true,
  },
  // Profile
  {
    path: getRoute('profile'),
    exact: true,
    regions: {
      main: ProfileCover,
      side: Settings,
      canvas: ProfilePage,
    },
    mobileTopNav: null,
    prefetch: [EditProfileGenderPage, SelectAnthem, SelectTopArtists],
    animation: {
      main: mobileAnimation.initial,
      side: desktopSideAnimation.fromLeft,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'myProfile',
    },
  },
  {
    path: getRoute('profilePreview'),
    exact: true,
    regions: {
      main: ProfilePage,
      side: Settings,
      canvas: ProfilePage,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    animation: {
      main: mobileAnimation.slideUp,
      side: desktopSideAnimation.initial,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'myProfile',
    },
  },
  {
    // page title set in container
    path: getRoute('subscriptionSettings'),
    exact: true,
    regions: {
      main: SubscriptionMerchandisingPage,
      side: Settings,
      canvas: SubscriptionMerchandisingPage,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    onEnter: verifyMerchandisingRoute,
    animation: {
      main: mobileAnimation.slideUp,
      side: desktopSideAnimation.fromLeft,
      canvas: desktopCanvasAnimation.fade,
    },
  },
  {
    path: getRoute('editProfile'),
    exact: true,
    regions: {
      main: EditProfileMenuWithPreviewPage,
      side: Settings,
      canvas: EditProfileMenuWithPreviewPage,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    prefetch: [EditProfileGenderPage, SelectAnthem, SelectTopArtists],
    animation: {
      main: mobileAnimation.slideUp,
      side: desktopSideAnimation.fromLeft,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'ProfileCard.EditInfo',
    },
  },
  {
    path: getRoute('passport'),
    exact: true,
    regions: {
      main: PassportPage,
      side: Settings,
      canvas: PassportPage,
    },
    mobileBottomNav: null,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromLeft,
      canvas: desktopCanvasAnimation.fade,
    },
    pageMeta: {
      titleIntlId: 'ProfileCard.EditInfo',
    },
  },
  {
    path: getRoute('editProfileGender'),
    exact: true,
    regions: {
      main: EditProfileGenderPage,
      side: Settings,
      canvas: EditProfileGenderPage,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromLeft,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'EditProfile.CurrentGender', // @TODO probably better translation
    },
  },
  {
    path: getRoute('editProfileSelectAnthem'),
    exact: true,
    regions: {
      main: SelectAnthem,
      side: Settings,
      canvas: SelectAnthem,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromLeft,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'EditProfile.chooseAnthem',
    },
  },
  {
    path: getRoute('editProfileSelectTopArtists'),
    exact: true,
    regions: {
      main: SelectTopArtists,
      side: Settings,
      canvas: SelectTopArtists,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromLeft,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'TopArtists.title',
    },
  },
  {
    path: getRoute('editProfileLivingIn'),
    exact: true,
    regions: {
      main: SelectCity,
      side: Settings,
      canvas: SelectCity,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromLeft,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'HomeCity.editCity',
    },
  },
  {
    path: getRoute('editProfileStickers'),
    exact: true,
    regions: {
      main: EditStickers,
      side: Settings,
      canvas: EditStickers,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromLeft,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'EditProfile.stickerLabel',
    },
  },
  {
    path: getRoute('editProfileInterests'),
    exact: true,
    regions: {
      main: SelectInterests,
      side: Settings,
      canvas: SelectInterests,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromLeft,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'Alibi.editInterest',
    },
  },
  {
    path: getRoute('editProfileSelectSchool'),
    exact: true,
    regions: {
      main: SelectSchool,
      side: Settings,
      canvas: SelectSchool,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromLeft,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'EditProfile.addSchool',
    },
  },
  {
    path: getRoute('editProfileGenderSearch'),
    exact: true,
    regions: {
      main: ConnectedSearchGenders,
      side: Settings,
      canvas: ConnectedSearchGenders,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromLeft,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'EditProfile.CurrentGender',
    },
  },
  {
    path: getRoute('editProfileOrientation'),
    exact: true,
    regions: {
      main: EditProfileOrientationPage,
      side: Settings,
      canvas: EditProfileOrientationPage,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromLeft,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'Orientation.orientation',
    },
  },
  {
    path: getRoute('editProfilePrompts'),
    exact: true,
    regions: {
      main: EditProfilePromptsPage,
      side: Settings,
      canvas: EditProfilePromptsPage,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    onEnter: redirectToEditProfile,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromLeft,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'prompt',
    },
  },
  // Settings
  {
    path: getRoute('settings'),
    exact: true,
    regions: {
      main: Settings,
      side: Settings,
      canvas: ProfilePage,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    animation: {
      main: mobileAnimation.slideUp,
      side: desktopSideAnimation.fromLeft,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'settings',
    },
  },
  {
    path: getRoute('accountSettings'),
    exact: true,
    regions: {
      main: AccountSettings,
      side: AccountSettings,
      canvas: ProfilePage,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    onEnter: verifyPlusRoute,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromRight,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'accountSettings',
    },
  },
  {
    path: getRoute('exListAddContact'),
    exact: true,
    regions: {
      main: ExListAddContact,
      side: ExListAddContact,
      canvas: ProfilePage,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    onEnter: verifyPlusRoute,
    animation: {
      main: mobileAnimation.slideUp,
      side: desktopSideAnimation.fromRight,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'ExList.addContactTitle',
    },
  },
  {
    path: getRoute('exListSettings', {
      pathConfig: { removeRegex: false },
    }),
    exact: true,
    regions: {
      main: ExListSettings,
      side: ExListSettings,
      canvas: ProfilePage,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    onEnter: verifyPlusRoute,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromRight,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'ExList.blockContactsTitle',
    },
  },
  {
    path: MUTUAL_FRIENDS_SETTINGS_ROUTE,
    exact: true,
    regions: {
      main: MutualFriendsSubSettings,
      side: MutualFriendsSubSettings,
      canvas: ProfilePage,
    },
    onEnter: verifyMutualFriendsRoute,
    mobileBottomNav: null,
    mobileTopNav: null,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromRight,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: MUTUAL_FRIENDS_MENU_ITEM_TITLE_ID,
    },
  },
  {
    path: getRoute('updateCard'),
    exact: true,
    regions: {
      main: UpdateCard,
      side: AccountSettings,
      canvas: UpdateCard,
    },
    mobileBottomNav: null,
    onEnter: verifyPlusRoute,
    pageMeta: {
      titleIntlId: 'TinderPlus.updateCard',
    },
  },
  {
    path: getRoute('webProfileSettings'),
    exact: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    regions: {
      main: WebProfileSettings,
      side: WebProfileSettings,
      canvas: ProfilePage,
    },
    onEnter: verifySettingsRoute,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromRight,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'WebProfile.webProfile',
    },
  },
  {
    path: getRoute('messageDataConsentSettings'),
    exact: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    regions: {
      main: SuggestionsConsentSettings,
      side: SuggestionsConsentSettings,
      canvas: ProfilePage,
    },
    onEnter: verifySettingsRoute,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromRight,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'MessageDataConsent.messageDataConsent',
    },
  },
  {
    path: getRoute('readReceiptSettings'),
    exact: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    regions: {
      main: ReadReceiptSettings,
      side: ReadReceiptSettings,
      canvas: ProfilePage,
    },
    onEnter: verifySettingsRoute,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromRight,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'ReadReceipts.readReceipts',
    },
  },
  {
    path: getRoute('recentlyActiveSettings'),
    exact: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    regions: {
      main: RecentlyActiveSettings,
      side: RecentlyActiveSettings,
      canvas: ProfilePage,
    },
    onEnter: verifySettingsRoute,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromRight,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'TinderGold.recentlyActiveStatus',
    },
  },
  isEnabled('devTools') && {
    path: getRoute('levers'),
    exact: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    regions: {
      main: LeverOverrideSettings,
      side: LeverOverrideSettings,
      canvas: ProfilePage,
    },
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromRight,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      title: 'Levers',
    },
  },
  isEnabled('stacksUtil') && {
    path: getRoute('stacksUtil'),
    exact: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    regions: {
      main: StacksUtil,
      side: StacksUtil,
      canvas: ProfilePage,
    },
    onEnter: redirectToSettings,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromRight,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      title: 'Stacks Util',
    },
  },
  {
    path: getRoute('preferencesInterestsSelection'),
    exact: true,
    regions: {
      main: PreferencesInterestsSelection,
      side: PreferencesInterestsSelection,
      canvas: ProfilePage,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    onEnter: verifyPreferencesRoute,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromRight,
      canvas: desktopCanvasAnimation.initial,
    },
  },
  {
    path: getRoute('preferencesDescriptorSelection'),
    exact: true,
    regions: {
      main: PreferencesDescriptorSelection,
      side: PreferencesDescriptorSelection,
      canvas: ProfilePage,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    onEnter: verifyPreferencesRoute,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromRight,
      canvas: desktopCanvasAnimation.initial,
    },
  },
  {
    path: getRoute('emailNotificationSettings'),
    exact: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    regions: {
      main: EmailNotificationSettings,
      side: EmailNotificationSettings,
      canvas: ProfilePage,
    },
    onEnter: verifySettingsRoute,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromRight,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'email',
    },
  },
  {
    path: getRoute('emailAccountSettings'),
    exact: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    regions: {
      main: EmailAccountSettings,
      side: EmailAccountSettings,
      canvas: ProfilePage,
    },
    onEnter: verifySettingsRoute,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromRight,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'email',
    },
  },
  {
    path: getRoute('connectedAccountsSettings'),
    mobileBottomNav: null,
    mobileTopNav: null,
    exact: true,
    regions: {
      main: ConnectedAccountsSettings,
      side: ConnectedAccountsSettings,
      canvas: ProfilePage,
    },
    onEnter: verifySettingsRoute,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromRight,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'Settings.connectedAccounts',
    },
  },
  {
    path: getRoute('phoneAccountSettings'),
    exact: true,
    regions: {
      main: PhoneAccountSettings,
      side: PhoneAccountSettings,
      canvas: ProfilePage,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    onEnter: verifySettingsRoute,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromRight,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'phoneNumber',
    },
  },
  {
    path: getRoute('messageControlsSettings'),
    exact: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    regions: {
      main: MessageControlsSettings,
      side: MessageControlsSettings,
      canvas: ProfilePage,
    },
    onEnter: verifySettingsRoute,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromRight,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'Settings.messageControls',
    },
  },
  {
    path: getRoute('tinderUSettings'),
    exact: true,
    regions: {
      main: TinderUSettingsMenu,
      side: TinderUSettingsMenu,
      canvas: ProfilePage,
    },
    mobileBottomNav: null,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromRight,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'TinderU.title',
    },
  },
  {
    path: getRoute('globalModeLanguagePreferences'),
    exact: true,
    regions: {
      main: GlobalModeSettings,
      side: GlobalModeSettings,
      canvas: ProfilePage,
    },
    mobileBottomNav: null,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromRight,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'GlobalMode.selectLanguages',
    },
  },
  {
    path: getRoute('pushNotificationSettings'),
    exact: true,
    regions: {
      main: PushNotificationSettings,
      side: PushNotificationSettings,
      canvas: ProfilePage,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    onEnter: verifySettingsRoute,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromRight,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'pushNotifications',
    },
  },
  {
    path: getRoute('subSetting'),
    exact: true,
    regions: {
      main: SubSettings,
      side: SubSettings,
      canvas: ProfilePage,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    onEnter: verifySettingsRoute,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromRight,
      canvas: desktopCanvasAnimation.initial,
    },
  },
  // Match
  {
    path: getRoute('matches'),
    exact: true,
    regions: {
      main: MatchlistPage,
      side: DesktopMessageList,
      canvas: RecsPage,
    },
    showMobileBackground: true,
    prefetch: [RecProfile],
    mobileTopNav: <MatchlistPageTopNav />,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.initial,
      canvas: desktopCanvasAnimation.initial,
    },
  },
  {
    path: getRoute('messageMatch', {
      pathConfig: { removeRegex: false },
    }),
    exact: true,
    regions: {
      main: Chat,
      side: DesktopMessageList,
      canvas: DesktopChat,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    onEnter: verifyMessagesRoute,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.initial,
      canvas: desktopCanvasAnimation.fromRight,
    },
  },
  {
    path: getRoute('messageMatchProfile', {
      pathConfig: { removeRegex: false },
    }),
    exact: true,
    regions: {
      main: ChatProfile,
      side: DesktopMessageList,
      canvas: ChatProfile,
    },
    mobileBottomNav: null,
    onEnter: verifyMessagesRoute,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.initial,
      canvas: desktopCanvasAnimation.fade,
    },
  },
  // Recs
  {
    path: getRoute('recsProfile'),
    exact: true,
    onEnter: redirectToRecs,
    mobileBottomNav: null,
    mobileTopNav: null,
    regions: {
      main: RecProfile,
      side: DesktopMessageList,
      canvas: RecProfile,
    },
    animation: {
      main: mobileAnimation.zoom,
      side: desktopSideAnimation.initial,
      canvas: desktopCanvasAnimation.initial,
    },
  },
  {
    path: getRoute('likesYou'),
    exact: true,
    regions: {
      main: LikesYou,
      side: DesktopMessageList,
      canvas: LikesYou,
    },
    onEnter: verifyGoldRoute,
    mobileTopNav: null,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.initial,
      canvas: desktopCanvasAnimation.fade,
    },
    pageMeta: {
      titleIntlId: 'TinderGold.likesYou',
    },
    props: {
      main: {
        pageName: LIKES_YOU_TAB,
      },
      canvas: {
        pageName: LIKES_YOU_TAB,
      },
    },
  },
  // Gold Home
  {
    path: getRoute('goldHome'),
    exact: true,
    regions: {
      main: LikesYou,
      side: DesktopMessageList,
      canvas: LikesYou,
    },
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.initial,
      canvas: desktopCanvasAnimation.fade,
    },
    onEnter: verifyGoldRoute,
    showMobileBackground: true,
    props: {
      main: {
        isTabbed: true,
        pageName: LIKES_YOU_TAB,
      },
    },
    pageMeta: {
      titleIntlId: 'TinderGold.likesYou',
    },
  },
  // My likes
  {
    path: getRoute('myLikes'),
    exact: true,
    regions: {
      main: LikesYou,
      side: DesktopMessageList,
      canvas: LikesYou,
    },
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.initial,
      canvas: desktopCanvasAnimation.fade,
    },
    onEnter: verifyGoldRoute,
    props: {
      main: {
        isTabbed: true,
        pageName: MY_LIKES_TAB,
      },
      canvas: {
        pageName: MY_LIKES_TAB,
      },
    },
    pageMeta: {
      titleIntlId: 'likesSent',
    },
  },
  {
    path: getRoute('selfieChallenge'),
    exact: true,
    regions: {
      main: SelfieChallenge,
      side: null,
      canvas: SelfieChallenge,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
  },
  {
    path: getRoute('matchExpirationArchived'),
    exact: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    regions: {
      main: MatchExpirationArchived,
      side: MatchExpirationArchived,
      canvas: RecsPage,
    },
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.initial,
      canvas: desktopCanvasAnimation.initial,
    },
  },
  isEnabled('matchmaker') && {
    path: getRoute('mmProfile'),
    exact: true,
    ignoreAuthCheck: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    regions: {
      main: MmProfile,
      side: null,
      canvas: MmProfile,
    },
    animation: {
      main: mobileAnimation.zoom,
      side: desktopSideAnimation.initial,
      canvas: desktopCanvasAnimation.initial,
    },
  },
  isEnabled('matchmaker') && {
    path: getRoute('mmEntry'),
    ignoreAuthCheck: true,
    exact: true,
    regions: {
      main: MmEntry,
      side: null,
      canvas: MmEntry,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
  },
  {
    path: getRoute('explore'),
    exact: true,
    regions: {
      main: ExploreCatalogPage,
      side: ExploreCatalogPage,
      canvas: ExploreCuratedRecsPage,
    },
    animation: {
      main: mobileAnimation.initial,
      side: desktopSideAnimation.initial,
      canvas: desktopCanvasAnimation.initial,
    },
    pageMeta: {
      titleIntlId: 'explore',
    },
    onEnter: verifyExploreRoute,
  },
  {
    path: getRoute('exploreCuratedRecs'),
    exact: true,
    regions: {
      main: ExploreCuratedRecsPage,
      side: ExploreCatalogPage,
      canvas: ExploreCuratedRecsPage,
    },
    onEnter: redirectToExplore,
    mobileBottomNav: null,
    mobileTopNav: null,
    animation: {
      main: mobileAnimation.slideUp,
      side: desktopSideAnimation.initial,
      canvas: desktopCanvasAnimation.initial,
    },
  },
  // Unauth
  {
    path: '/',
    exact: true,
    authed: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    regions: {
      main: isEnabled('liteHomepage') || isInStandaloneMode ? LoginLite : LoginMobile,
      side: null,
      canvas: isEnabled('liteHomepage') || isInStandaloneMode ? LoginLite : LoginDesktop,
    },
  },
  {
    path: getRoute('international', {
      pathConfig: { removeRegex: false, withPrefix: false },
    }),
    exact: true,
    authed: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    regions: {
      main: isEnabled('liteHomepage') || isInStandaloneMode ? LoginLite : LoginMobile,
      side: null,
      canvas: isEnabled('liteHomepage') || isInStandaloneMode ? LoginLite : LoginDesktop,
    },
  },
  {
    path: getRoute('warden', {
      pathConfig: { removeRegex: false },
    }),
    exact: true,
    ignoreAuthCheck: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    regions: {
      main: WardenPage,
      side: null,
      canvas: WardenPage,
    },
  },
  {
    path: getRoute('selfieChallengeV2', {
      pathConfig: { removeRegex: false },
    }),
    exact: true,
    ignoreAuthCheck: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    regions: {
      main: SelfieChallengeV2,
      side: null,
      canvas: SelfieChallengeV2,
    },
  },
  {
    path: getRoute('loginLegacy'),
    exact: true,
    authed: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    regions: {
      main: LoginMobile,
      side: null,
      canvas: LoginDesktop,
    },
    onEnter: handleLoginRoute,
  },
  {
    path: getRoute('verify'),
    exact: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    ignoreAuthCheck: true,
    regions: {
      main: UserVerification,
      side: null,
      canvas: UserVerification,
    },
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.initial,
      canvas: desktopCanvasAnimation.initial,
    },
  },
  {
    path: getRoute('onboarding'),
    exact: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    ignoreAuthCheck: true,
    hasEncasedLandmarks: true,
    regions: {
      main: AuthOnboarding,
      side: null,
      canvas: AuthOnboarding,
    },
  },
  {
    path: getRoute('checkout'),
    exact: true,
    regions: {
      main: Checkout,
      side: Settings,
      canvas: Checkout,
    },
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromLeft,
      canvas: desktopCanvasAnimation.fade,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    pageMeta: {
      titleIntlId: 'TinderPlus.checkout',
    },
  },
  {
    path: getRoute('addCard'),
    exact: true,
    regions: {
      main: UpdateCard,
      side: AccountSettings,
      canvas: UpdateCard,
    },
    onEnter: verifyPlusRoute,
    mobileBottomNav: null,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromLeft,
      canvas: desktopCanvasAnimation.fade,
    },
    pageMeta: {
      titleIntlId: 'TinderPlus.addCard',
    },
  },
  {
    path: getRoute('preCheckout'),
    exact: true,
    regions: {
      main: PreCheckout,
      side: Settings,
      canvas: PreCheckout,
    },
    onEnter: verifyCheckoutRoute,
    mobileBottomNav: null,
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromLeft,
      canvas: desktopCanvasAnimation.fade,
    },
  },
  {
    path: getRoute('error'),
    exact: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    regions: {
      main: ServiceUnavailablePage,
      canvas: ServiceUnavailablePage,
    },
    pageMeta: {
      titleIntlId: 'oops',
    },
  },
  {
    path: getRoute('promo'),
    ignoreAuthCheck: true,
    mobileBottomNav: null,
    regions: {
      main: LoadingScreen,
      side: null,
      canvas: LoadingScreen,
    },
    onEnter: verifyPromoRoute,
  },
  {
    path: getRoute('emailRemove'),
    exact: true,
    ignoreAuthCheck: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    regions: {
      main: EmailRemovalPage,
      canvas: EmailRemovalPage,
    },
  },
  {
    path: getRoute('emailSubscriptionService'),
    exact: true,
    ignoreAuthCheck: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    regions: {
      main: EmailSubscriptionPage,
      canvas: EmailSubscriptionPage,
    },
    onEnter: verifyEmailSubscriptionTokenRoute,
  },
  {
    path: getRoute('deeplinkRemoveEmail'),
    ignoreAuthCheck: true,
    mobileBottomNav: null,
    regions: {
      main: LoadingScreen,
      side: null,
      canvas: LoadingScreen,
    },
    onEnter: verifyEmailRemovalDeeplinkRoute,
  },
  // Deeplink
  {
    path: getRoute('deeplinkConfirm', {
      pathConfig: { withPrefix: false },
    }),
    // will render child regardless of auth status
    ignoreAuthCheck: true,
    mobileBottomNav: null,
    regions: {
      main: LoadingScreen,
      side: null,
      canvas: LoadingScreen,
    },
    onEnter: verifyConfirmationDeeplinkRoute,
  },
  {
    path: getRoute('deeplinkToGold'),
    ignoreAuthCheck: true,
    mobileBottomNav: null,
    regions: {
      main: LoadingScreen,
      side: null,
      canvas: LoadingScreen,
    },
    onEnter: verifyGoldDeeplinkRoute,
  },
  {
    path: getRoute('deeplinkToIncentives', {
      pathConfig: { withPrefix: false },
    }),
    ignoreAuthCheck: true,
    mobileBottomNav: null,
    regions: {
      main: LoadingScreen,
      side: null,
      canvas: LoadingScreen,
    },
    onEnter: verifyIncentivesDeeplinkRoute,
  },
  {
    path: getRoute('deeplinkToCampaign'),
    ignoreAuthCheck: true,
    mobileBottomNav: null,
    regions: {
      main: LoadingScreen,
      side: null,
      canvas: LoadingScreen,
    },
    onEnter: verifyCampaignDeeplinkRoute,
  },
  {
    path: getRoute('deeplinkToAgeVerification', {
      pathConfig: { withPrefix: false },
    }),
    ignoreAuthCheck: true,
    mobileBottomNav: null,
    regions: {
      main: LoadingScreen,
      side: null,
      canvas: LoadingScreen,
    },
    onEnter: verifyAgeVerificationDeeplinkRoute,
  },
  {
    path: getRoute('deeplinkNavigate', {
      pathConfig: { withPrefix: false },
    }),
    exact: true,
    ignoreAuthCheck: true,
    mobileBottomNav: null,
    regions: {
      main: LoadingScreen,
      side: null,
      canvas: LoadingScreen,
    },
    onEnter: verifyNavigateRoute,
  },
  {
    path: getRoute('remote'),
    exact: true,
    ignoreAuthCheck: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    regions: {
      main: RemoteView,
      side: null,
      canvas: RemoteView,
    },
  },
  {
    path: getRoute('webProfile', {
      pathConfig: { withPrefix: false },
    }),
    exact: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    ignoreAuthCheck: true,
    regions: {
      main: WebProfile,
      side: null,
      canvas: WebProfile,
    },
    onEnter: verifyWebProfileRoute,
  },
  {
    path: getRoute('campaign', {
      pathConfig: { withPrefix: false },
    }),
    exact: true,
    ignoreAuthCheck: true,
    regions: {
      main: Campaign,
      side: null,
      canvas: Campaign,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    animation: {
      main: mobileAnimation.initial,
      side: desktopSideAnimation.initial,
      canvas: desktopCanvasAnimation.initial,
    },
  },
  {
    path: getRoute('appealsCenter', {
      pathConfig: { withPrefix: false },
    }),
    ignoreAuthCheck: true,
    exact: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    regions: {
      main: AppealsCenterPage,
      canvas: AppealsCenterPage,
    },
  },
  {
    path: getRoute('biometrics'),
    ignoreAuthCheck: true,
    exact: true,
    mobileBottomNav: null,
    mobileTopNav: null,
    regions: {
      main: UserBiometrics,
      canvas: UserBiometrics,
    },
  },
  isEnabled('tinderSelectOnboarding') && {
    path: getRoute('tinderSelect', {
      pathConfig: { withPrefix: false },
    }),
    exact: true,
    ignoreAuthCheck: true,
    regions: {
      main: TinderSelectOnboarding,
      side: null,
      canvas: TinderSelectOnboarding,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    animation: {
      main: mobileAnimation.initial,
      side: desktopSideAnimation.initial,
      canvas: desktopCanvasAnimation.initial,
    },
  },
  isEnabled('tinderSelectCheckout') && {
    path: getRoute('selectPreCheckout', {
      pathConfig: { withPrefix: false },
    }),
    ignoreAuthCheck: true,
    exact: true,
    regions: {
      main: TinderSelectPreCheckoutPage,
      side: null,
      canvas: TinderSelectPreCheckoutPage,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    animation: {
      main: mobileAnimation.initial,
      side: desktopSideAnimation.initial,
      canvas: desktopCanvasAnimation.initial,
    },
  },
  isEnabled('tinderSelectCheckout') && {
    path: getRoute('selectCheckout', {
      pathConfig: { withPrefix: false },
    }),
    exact: true,
    ignoreAuthCheck: true,
    regions: {
      main: Checkout,
      side: null,
      canvas: Checkout,
    },
    animation: {
      main: mobileAnimation.fade,
      side: desktopSideAnimation.fromLeft,
      canvas: desktopCanvasAnimation.fade,
    },
    mobileBottomNav: null,
    mobileTopNav: null,
    pageMeta: {
      titleIntlId: 'TinderPlus.checkout',
    },
  },
  isEnabled('giftCard') && {
    path: getRoute('giftCardRedeem', {
      pathConfig: { withPrefix: false },
    }),
    exact: true,
    ignoreAuthCheck: true,
    regions: {
      main: GiftCardPage,
      side: null,
      canvas: GiftCardPage,
    },
    mobileTopNav: null,
    mobileBottomNav: null,
  },
  isEnabled('giftCard') && {
    path: getRoute('gift', {
      pathConfig: { withPrefix: false },
    }),
    exact: true,
    ignoreAuthCheck: true,
    regions: {
      main: GiftCardPage,
      side: null,
      canvas: GiftCardPage,
    },
    mobileTopNav: null,
    mobileBottomNav: null,
    onEnter: redirectToGiftCard,
  },
  // redirect
  {
    path: getRoute('prefix'),
    exact: true,
    regions: {
      main: NotFoundPage,
      canvas: NotFoundPage,
    },
    onEnter: redirectToRecs,
  },
  // homescreen start_url
  {
    path: '/index.html',
    exact: true,
    regions: {
      main: RecsPage,
      side: DesktopMessageList,
      canvas: RecsPage,
    },
    onEnter: redirectToRoot,
  },
  {
    path: '*',
    regions: {
      main: NotFoundPage,
      canvas: NotFoundPage,
    },
    pageMeta: {
      titleIntlId: 'oops',
    },
  },
].filter(Boolean);

export default routesConfig;
